// Google Analytics 4 event tracking module

/**
 * Push an event to the Google Analytics dataLayer
 * @param {Object} eventData - The event data object
 * @param {boolean} clearEcommerce - Whether to clear ecommerce data first
 */
export function pushAnalyticsEvent(eventData, clearEcommerce = false) {
  if (!window.dataLayer) {
    console.warn('Google Analytics dataLayer not available');
    return;
  }

  if (clearEcommerce) {
    window.dataLayer.push({ ecommerce: null });
  }

  window.dataLayer.push(eventData);
}

/**
 * Process all GA4 event elements on the page
 */
function processAnalyticsEvents() {
  // Process ecommerce events
  document.querySelectorAll('[data-ga4-ecommerce-event]').forEach(element => {
    try {
      const eventData = JSON.parse(element.dataset.ga4EcommerceEvent);
      pushAnalyticsEvent(eventData, true);
      element.removeAttribute('data-ga4-ecommerce-event'); // Process only once
    } catch (error) {
      console.error('Failed to process GA4 ecommerce event:', error);
    }
  });

  // Process standard events
  document.querySelectorAll('[data-ga4-event]').forEach(element => {
    try {
      const eventData = JSON.parse(element.dataset.ga4Event);
      pushAnalyticsEvent(eventData, false);
      element.removeAttribute('data-ga4-event'); // Process only once
    } catch (error) {
      console.error('Failed to process GA4 event:', error);
    }
  });
}

// Auto-process events on Turbo load
document.addEventListener('turbo:load', processAnalyticsEvents);

// Also process on initial page load (for non-Turbo navigation)
if (document.readyState === 'loading') {
  document.addEventListener('DOMContentLoaded', processAnalyticsEvents);
} else {
  processAnalyticsEvents();
}
